export const MaxWidgetSize = 10;
